import { BaseListParams } from "../../core/models/base-requests.model";

export class GenericItemsPositionsUpdateParams extends BaseListParams {
  AppItemID: number;
  Items: number[] = [];
  ItemsType: string;
}
